import React, {useState} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Button} from "@mui/material";

import {greyishBlue600, orange50, red50} from "assets/jss/main";

import {formatDateTime} from "views/personalShopper/components/formatters";

import SideCard from "./SideCard";

AlertsCard.propTypes = {
    escalations: PropTypes.arrayOf(PropTypes.object).isRequired,
    onHandle: PropTypes.func.isRequired,
};

/**
 * The hand-over requests: what the assistant could not answer, a complaint, a shopper in
 * distress, a failure. Open ones first; "handled" once a person dealt with it.
 */
function AlertsCard({escalations, onHandle}) {
    const [busyId, setBusyId] = useState(null);

    if (escalations.length === 0) {
        return null;
    }

    const sorted = [...escalations].sort((a, b) => (a.status === b.status ? 0 : (a.status === "open" ? -1 : 1)));

    return (
        <SideCard titleId="personalShopper.alerts.title">
            {sorted.map((escalation) => (
                <div
                    key={escalation.id}
                    style={{
                        padding: "8px 10px",
                        borderRadius: "8px",
                        marginBottom: "8px",
                        backgroundColor: escalation.status === "open" ? (escalation.urgent ? red50 : orange50) : "transparent",
                        border: escalation.status === "open" ? "none" : "1px solid #E6E7EB",
                        fontSize: "13px",
                    }}
                >
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px"}}>
                        <strong><FormattedMessage id={`personalShopper.escalation.${escalation.category}`} /></strong>
                        {escalation.status === "open" ? (
                            <Button
                                size="small"
                                variant="contained"
                                disabled={busyId === escalation.id}
                                onClick={() => {
                                    setBusyId(escalation.id);
                                    onHandle(escalation.id).finally(() => setBusyId(null));
                                }}
                                sx={{textTransform: "none"}}
                            >
                                <FormattedMessage id="personalShopper.alerts.markHandled" />
                            </Button>
                        ) : (
                            <span style={{color: greyishBlue600, fontSize: "12px"}}>
                                <FormattedMessage id="personalShopper.alerts.handledBy" values={{who: escalation.handledBy, date: formatDateTime(escalation.handledAt)}} />
                            </span>
                        )}
                    </div>
                    <div style={{color: greyishBlue600, fontSize: "12px", margin: "2px 0"}}>{formatDateTime(escalation.createdAt)}</div>
                    <div style={{whiteSpace: "pre-wrap"}}>{escalation.reason}</div>
                </div>
            ))}
        </SideCard>
    );
}

export default AlertsCard;
